import { contactInfo, waLink, waMessages } from '../data/content';
import './Contacto.css';

export default function Contacto() {
  return (
    <section id="contacto" className="contacto">
      <div className="contacto__panel pin-dark">
        <div className="contacto__kanji-bg">構</div>
        <div className="contacto__grid">
          <div>
            <div className="contacto__eyebrow">Únete al Dojo</div>
            <h2 className="contacto__title">
              Agenda tu <span className="text-red">primera clase</span>
            </h2>
            <p className="contacto__lead">
              Programas para todas las edades. Da el primer paso en el camino
              del Karate Do Shito Ryu.
            </p>
            <div className="contacto__chips">
              <span className="contacto__chip">Infantil</span>
              <span className="contacto__chip">Juvenil</span>
              <span className="contacto__chip">Adultos</span>
            </div>
            <div className="contacto__actions">
              <a
                href={waLink(waMessages.general)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--primary"
              >
                Escríbenos por WhatsApp <span className="btn__arrow">→</span>
              </a>
              <a
                href="https://instagram.com/dojokamae"
                target="_blank"
                rel="noopener noreferrer"
                className="contacto__ig"
              >
                @dojokamae <span className="btn__arrow">↗</span>
              </a>
            </div>
          </div>

          <div className="contacto__card">
            {contactInfo.map((info, i) => (
              <div key={info.label}>
                {i > 0 && <div className="contacto__divider" />}
                <div className="contacto__info">
                  <div className="contacto__info-label">{info.label}</div>
                  <div className="contacto__info-title">{info.title}</div>
                  {info.subtitle && (
                    <div className="contacto__info-subtitle">
                      {info.subtitle}
                    </div>
                  )}
                  {info.href && (
                    <a
                      href={info.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contacto__info-link"
                    >
                      {info.linkLabel} <span aria-hidden="true">↗</span>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}